module.exports = __webpack_public_path__ + "img/ebulletin.9499fcbd.png";